// Barrel export — backwards-compatible flat object matching the original api.js shape

import { client } from './client';
import * as auth from './auth';
import * as user from './user';
import * as suppliers from './suppliers';
import * as services from './services';
import * as invoices from './invoices';
import * as readings from './readings';
import * as credentials from './credentials';
import * as readingTemplates from './reading-templates';
import * as invoiceTemplates from './invoice-templates';
import * as actions from './actions';
import * as reminders from './reminders';
import * as apiKeys from './api-keys';
import * as inviteCodes from './invite-codes';
import * as notifications from './notifications';
import * as push from './push';
import * as dashboard from './dashboard';
import * as files from './files';
import { normalizeFieldErrors } from './helpers';

// Named export for consumers that import { normalizeFieldErrors }
export { normalizeFieldErrors };

// Backwards-compatible default export — flat object with all function names
export default {
    client,
    ...auth,
    ...user,
    ...suppliers,
    ...services,
    ...invoices,
    ...readings,
    ...credentials,
    ...readingTemplates,
    ...invoiceTemplates,
    ...actions,
    ...reminders,
    ...apiKeys,
    ...inviteCodes,
    ...notifications,
    ...push,
    ...dashboard,
    ...files,
};
